import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import NiceModal from '@ebay/nice-modal-react';
import { keys } from 'lodash';

const HideModalsOnRouteChange = () => {
  const { pathname } = useLocation();
  const modals = useContext(NiceModal.NiceModalContext);
  const modalsRef = useRef(modals);
  modalsRef.current = modals;
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    keys(modalsRef.current).forEach(modalId => NiceModal.hide(modalId));
  }, [pathname]);

  return null;
};

export default HideModalsOnRouteChange;
